<!-- <div class="course-item mb-4" id="{{ 'courses_div'+ course.id }}" [ngClass]="{'home-course': pageName == 'home'}">
    <div class="course-featured-image" (click)="details(course)">
        <img [src]="course.logo_link.replace('https://s3-ap-south-1.amazonaws.com/iquantamedia', 'https://media.iquanta.in')" alt="{{course.course_name.split('.')[1]}}" loading="lazy">
    </div>
    <div class="course-info-content">
        <h3 *ngIf="course.course_name.includes('.')" class="mb-0 px-3 py-2">{{course.course_name.split('.')[1]}}</h3>
        <h3 *ngIf="!course.course_name.includes('.')" class="mb-0 px-3 py-2">{{course.course_name}}
        </h3>

        <div class="course-text px-3 py-2 ">
            <p [innerHTML]="course.speciality | safeHtml"></p>
        </div>

        
    </div>
    <div *ngIf="course.display_only_one">
        <div class="c_footer d-flex p-2 mt-1 align-items-center">
            <div class="price_range mr-auto">
                <span class="mr-auto f-bold">
                    {{course.offer_price|currency}}</span>
                <small class="me-auto f-light mt-1" *ngIf="course.actual_price != course.offer_price"><del>
                        {{course.actual_price|currency}}</del></small>
            </div>
            <button class="btn f-bold p-2 text-white rounded-pill" (click)="buynow(course)">
                Course Structure & Discount
            </button>
        </div>
    </div>
</div> -->

<!-- <div class="c_grid" id="{{ 'courses_div'+ course.id }}"  [ngClass]="{'home-course': pageName == 'home'}">
    <div class="clearfix  c_grid_banner" (click)="details(course)" >
        <img [src]="course.logo_link.replace('https://s3-ap-south-1.amazonaws.com/iquantamedia', 'https://media.iquanta.in')" alt="{{course.course_name.split('.')[1]}}" loading="lazy">
    </div>

    <div class="clearfix c_info px-3 py-2">
        <h4 *ngIf="course.course_name.includes('.')">
            {{course.course_name.split('.')[1]}}
        </h4>
        <h4 *ngIf="!course.course_name.includes('.')">{{course.course_name}}
        </h4>

        <ul>
            <li>
                <p [innerHTML]="course.speciality | safeHtml"></p>
            </li>
        </ul>

        <div >

            <div *ngIf="course.display_only_one">
                <div class="clearfix c_footer d-flex  d-flex p-0">
                    <div class="price_range mr-auto ">
                        <span class="mr-auto">
                            {{course.offer_price|currency}}</span>
    
    
                        <small class="me-auto" style="color: #8f9ca9;"
                            *ngIf="course.actual_price != course.offer_price"><del>
                                {{course.actual_price|currency}}</del></small>
                    </div>
                   <div class="mobile-none">
                    <button class="pushable" (click)="buynow(course)">
                        <div class="front">
                            Course Structure & Discount
                        </div>
                      </button>
                   </div>
                </div>
            </div>

            <div *ngIf="!course.display_only_one">

            <div class="clearfix c_footer  mobile-none ">
                <div class="d-md-flex">
                    <div class="price_range mr-auto ">
                        <span class="mr-auto">
                            {{course.offer_price|currency}}</span>
    
    
                        <small class="me-auto" style="color: #8f9ca9;"
                            *ngIf="course.actual_price != course.offer_price"><del>
                                {{course.actual_price|currency}}</del></small>
                    </div>
                    <div>
                        <button mat-button class="buyNow" style="margin-right: 10px;
                        " (click)="buynow(course)">Buy
                            now</button>
    
                        <button *ngIf="!course.display_only_one" (click)="details(course)" mat-button>Details</button>
                    </div>
                </div>
              

            </div>
            </div>
        </div>

        <div class="desk-none">
            <div *ngIf="course.display_only_one">
                <button class="pushable" (click)="buynow(course)">
                    <div class="front">
                        Course Structure & Discount
                    </div>
                  </button>
            </div>
            <div *ngIf="!course.display_only_one">
            <div class="clearfix c_footer  mobile_view_icons ">

                <span class="" style="margin-right:7px !important;">
                    {{course.offer_price|currency}}</span>


                <span class="me-auto" style="color: #8f9ca9;" *ngIf="course.actual_price != course.offer_price"><del>
                        {{course.actual_price|currency}}</del></span>



            </div>
            </div>
        </div>



    </div>

</div> -->


<div class="new-course-card">
    <div class="banner-img">
        <img [src]="course.logo_link.replace('https://s3-ap-south-1.amazonaws.com/iquantamedia', 'https://media.iquanta.in')" alt="{{course.course_name.split('.')[1]}}" loading="lazy">
    </div>
    <div class="course-content">
    <div class="course-highlights">
        <div class="tittle">
            <h3 *ngIf="course.course_name.includes('.')">
                {{course.course_name.split('.')[1]}}
            </h3>
            <h3 *ngIf="!course.course_name.includes('.')">{{course.course_name}}
            </h3>
            <p><span><i class="bi bi-star-fill"></i>4.95</span></p>
        </div>
        <div class="course-tag" >
            <ul *ngIf="getChipsData(course.features).length > 0">
                <li *ngFor="let features of getChipsData(course.features)">{{features}}</li>
                <!-- <li>IIM Calls Included</li> -->
            </ul>
        </div>
        </div>
        <div class="course-fatures" [ngClass]="{'course-features-big': getChipsData(course.features).length == 0}">
            <ul>
                <li> <p [innerHTML]="course.speciality | safeHtml"></p></li>
            </ul>
        </div>
        <div class="price">
           <div>
            <h4> {{course.offer_price|currency}}</h4>
            <h6><del>{{course.actual_price|currency}}</del></h6>
           </div>
            <p>or ₹{{getEmiAmount(course.offer_price)}}/mo for 6 months</p>
        </div>
        <div class="btns">
            <ul>
                <li> <button type="button" class="btn btn-primary f-medium" (click)="enrollNow(course)">Enroll Now</button></li>
                <li> <button type="button" class="btn btn-primary f-medium" (click)="buynow(course)"> Course Structure & Details </button></li>
            </ul>
        </div>
        <!-- <div class="seats">
            <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                <div class="progress-bar" style="width: 75%"></div>
              </div>
              <p>Only 54 Seats Lest</p>
              <h6><i class="bi bi-clock-fill"></i>7-day money-back guarantee</h6>
        </div> -->
    </div>
</div>
